function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import "./ProgressBar.css";
import classNames from 'classnames';

var ProgressBarBase =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ProgressBarBase, _Component);

  function ProgressBarBase() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBarBase.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        title = _this$props.title,
        displayPercent = _this$props.displayPercent,
        className = _this$props.className,
        percentageSuffix = _this$props.percentageSuffix;
    var progress = this.props.progress;

    if (progress > 100) {
      progress = 100;
    }

    if (progress < 0) {
      progress = 0;
    }

    var marginPercent = -(100 - progress);
    var marginOffset = progress === 0 ? '2%' : '0px';
    var progressBarStyle = {
      marginLeft: "calc(" + marginPercent + "% - " + marginOffset + ")"
    };
    var progressClasses = classNames('progress-linear', className);
    return React.createElement("div", {
      className: progressClasses
    }, title && React.createElement("div", {
      className: "progress-linear__title"
    }, title), React.createElement("div", {
      className: "progress-linear__background"
    }, React.createElement("div", {
      className: "progress-linear__gradient",
      tabIndex: "-1",
      style: progressBarStyle,
      role: "progressbar",
      "aria-valuenow": progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuetext": "" + progress + percentageSuffix + " " + label
    })), displayPercent && React.createElement("div", {
      className: "progress-linear__status"
    }, "" + progress + percentageSuffix));
  };

  return ProgressBarBase;
}(Component);

ProgressBarBase.propTypes = {
  /** String or Element to show to left of Progress Bar */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /** Percentage of 100 that is complete */
  progress: PropTypes.number.isRequired,

  /** Static text for "Complete", Required for assistive devices */
  label: PropTypes.string.isRequired,

  /** Show a metric display to the right of the bar */
  displayPercent: PropTypes.bool,

  /** Suffix of Percentage is displayed */
  percentageSuffix: PropTypes.string
};
ProgressBarBase.defaultProps = {
  progress: 0,
  displayPercent: false,
  percentageSuffix: '%',
  label: ''
};
export default ProgressBarBase;